module.exports = __webpack_public_path__ + "img/batang1.9c017ca2.png";